import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventVisibilityModeModel } from 'src/app/models/event-visibility-mode.model';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { RoleModel } from 'src/app/models/person/role.model';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';
import { TenantSubscriberModel } from 'src/app/models/subscription/tenant-subscriber.model';
import { TrainingCategoryModel } from 'src/app/models/training-category/training-category.model';
import { TrainingGroupModel } from 'src/app/models/training-group.model';
import { PublishingMode } from 'src/app/models/training/publishing-mode.model';

@Component({
  selector: 'app-event-publication-settings',
  standalone: false,
  templateUrl: './event-publication-settings.component.html',
  styleUrl: './event-publication-settings.component.scss',
})
export class EventPublicationSettingsComponent {
  @Input() publishingMode!: PublishingMode;
  @Input() isPublishedToSubscribers = false;
  @Input() isPrivatePublishing = false;
  @Input() isViewMode = false;
  @Input() isCourse = false;
  @Input() personCount = 0;

  @Input() visibilityMode!: EventVisibilityModeModel | null;
  @Input() selectedOrganizationUnitIds: string[] = [];
  
  @Input() allowSharingWithSubscribers: boolean = false;
  @Input() trainingGroupIds: string[] = [];
  @Input() trainingCategoryIds: string[] = [];
  @Input() subscriptionIds: string[] = [];
  @Input() roleIds: string[] = [];
  @Input() standardTrainingCategoryIds: string[] = [];

  @Input() organizationUnits: OrganisationUnitModel[] = [];
  @Input() trainingGroups: TrainingGroupModel[] = [];
  @Input() trainingCategories: TrainingCategoryModel[] = [];
  @Input() standardTrainingCategories: StandardTrainingCategoryViewModel[] = [];
  @Input() subscribers: TenantSubscriberModel[] = [];
  @Input() roles: RoleModel[] = [];
  @Input() usedStandardTrainingCategories: StandardTrainingCategoryViewModel[] = [];

  @Output() 
  visibilityModeChange = new EventEmitter<EventVisibilityModeModel | null>();

  @Output() 
  selectedOrganizationUnitIdsChange = new EventEmitter<string[]>();

  @Output() 
  trainingGroupIdsChange = new EventEmitter<string[]>();

  @Output() 
  trainingCategoryIdsChange = new EventEmitter<string[]>();

  @Output()
  standardTrainingCategoryIdsChange = new EventEmitter<string[]>();

  @Output() 
  subscriptionIdsChange = new EventEmitter<string[]>();

  @Output() 
  roleIdsChange = new EventEmitter<string[]>();

  @Output() 
  allowSharingWithSubscribersChange = new EventEmitter<boolean>();

  publishingModes = PublishingMode;
}
